import React from 'react';
import styled from '@emotion/styled';
import { designTokens } from '@platform-ui/design-system';
import { ProductAreaIcon } from './Icons';
import { useIdentity } from './hooks/useIdentity';

const TrainingCenter = styled.button({
  display: 'flex',
  flex: 1,
  'align-items': 'center',

  position: 'fixed',
  top: 'calc(100vh - 40px)',
  width: '224px',
  'min-width': '224px',
  height: '40px',
  cursor: 'pointer',

  padding: '0 16px 0 0',
  font: 'inherit',
  'background-color': `${designTokens.colors.darkGreen700}`,
  border: 'none',
  color: `${designTokens.colors.darkEmphasisMedium}`,

  'outline-width': '1px',
  'outline-style': 'solid',
  'outline-color': `${designTokens.colors.darkEmphasisLow}`,

  '&:focus': {
    'background-color': `${designTokens.colors.darkGreen600}`,
    'outline-width': '2px',
  },

  '&:visited': {
    'background-color': `${designTokens.colors.darkGreen600}`,
  },

  '&:hover': {
    'background-color': `${designTokens.colors.darkGreen800}`,
  },
});

const ButtonPlaceHolder = styled.div({
  height: '41px',
});

export const TrainingCenterButtonPlaceHolder = () => {
  const { data: identityData } = useIdentity();
  if (identityData?.language === 'en' && !!window.userpilot) {
    return <ButtonPlaceHolder />;
  } else {
    return null;
  }
};

const TrainingCenterButton = () => {
  const { data: identityData } = useIdentity();
  if (identityData?.language === 'en' && !!window.userpilot) {
    return (
      <TrainingCenter
        onClick={() => {
          window.userpilot.trigger('resource_center:hPhEnmQPb4');
        }}
      >
        <ProductAreaIcon area="Zuora/TrainingCenter" active={false} />
        <p>Training Center</p>
      </TrainingCenter>
    );
  } else {
    return null;
  }
};

export default TrainingCenterButton;
